import React, { useState } from "react";
// 从认证上下文中获取当前用户信息和登出方法
import { useAuth } from "../../contexts/AuthContext";
// 导入 Bootstrap 样式
import "bootstrap/dist/css/bootstrap.min.css";
// 导入 React-Bootstrap 组件
import { Card, Button, Alert } from "react-bootstrap";
// 导入 React Router 组件，用于页面导航和链接
import { Link, useNavigate } from "react-router-dom";

import "./Form.css";

const Dashboard = () => {
  // 获取当前用户和登出方法
  const { currentUser, logout } = useAuth();
  // 定义 error 状态用于存储错误提示信息
  const [error, setError] = useState("");
  // 定义 loading 状态，用于标识登出操作是否正在执行
  const [loading, setLoading] = useState(false);
  // 使用 useNavigate 实现页面跳转
  const navigate = useNavigate();

  // 处理登出操作的异步函数
  const handleLogout = async () => {
    // 清除之前的错误提示，并将加载状态设为 true
    setError("");
    setLoading(true);

    try {
      // 调用 logout 方法进行登出
      await logout();
      // 登出成功后跳转到登录页面
      navigate("/login");
    } catch (err) {
      // 如果出错，则在控制台输出错误，并更新错误提示信息
      console.error(err);
      setError("Failed to log out");
    } finally {
      // 无论成功或失败，最后都将加载状态设为 false
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      {/* 使用 Card 组件展示用户的基本信息 */}
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Profile</h2>
          {/* 如果存在错误信息，则显示 Alert 组件 */}
          {error && <Alert variant="danger">{error}</Alert>}
          {/* 显示当前用户的邮箱信息，使用可选链防止未定义 */}
          <strong>Email:</strong> {currentUser?.email}
          {/* 链接到更新资料页面 */}
          <Link to="/update-profile" className="btn btn-primary w-100 mt-3">
            Update Profile
          </Link>
        </Card.Body>
      </Card>

      {/* 登出按钮区域 */}
      <div className="w-100 text-center mt-2">
        {/* 按钮禁用状态由 loading 状态决定，加载时显示 “Logging out...” */}
        <Button variant="link" onClick={handleLogout} disabled={loading}>
          {loading ? "Logging out..." : "Log Out"}
        </Button>
      </div>
    </div>
  );
};

export default Dashboard;